import axios from 'axios';

// Base URL for API requests
const API_URL = 'https://api.jamboricg.com/api/socialcorporate/posts/';

/**
 * Service for Social Corporate Post API interactions
 */
const corporateService = {
    /**
     * Get all posts
     * @returns {Promise} Promise with posts data
     */
    getAllPosts: async () => {
        try {
            const response = await axios.get(API_URL);
            return response.data;
        } catch (error) {
            console.error('Error fetching posts:', error);
            throw error;
        }
    },

    /**
     * Get a single post by ID
     * @param {number} id Post ID
     * @returns {Promise} Promise with post data
     */
    getPostById: async (id) => {
        try {
            const response = await axios.get(`${API_URL}${id}/`);
            return response.data;
        } catch (error) {
            console.error(`Error fetching post #${id}:`, error);
            throw error;
        }
    },

    /**
     * Create a new post
     * @param {Object} postData Post data to create
     * @returns {Promise} Promise with created post data
     */
    createPost: async (postData) => {
        // If post contains an image, use FormData
        if (postData.image instanceof File) {
            const formData = new FormData();
            Object.keys(postData).forEach(key => {
                formData.append(key, postData[key]);
            });

            try {
                const response = await axios.post(API_URL, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                });
                return response.data;
            } catch (error) {
                console.error('Error creating post with image:', error);
                throw error;
            }
        } else {
            // Regular JSON post if no image
            try {
                const response = await axios.post(API_URL, postData);
                return response.data;
            } catch (error) {
                console.error('Error creating post:', error);
                throw error;
            }
        }
    },

    /**
     * Update an existing post
     * @param {number} id Post ID to update
     * @param {Object} postData Updated post data
     * @returns {Promise} Promise with updated post data
     */
    updatePost: async (id, postData) => {
        // If post contains an image, use FormData
        if (postData.image instanceof File) {
            const formData = new FormData();
            Object.keys(postData).forEach(key => {
                formData.append(key, postData[key]);
            });

            try {
                const response = await axios.put(`${API_URL}${id}/`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                });
                return response.data;
            } catch (error) {
                console.error(`Error updating post #${id} with image:`, error);
                throw error;
            }
        } else {
            // Regular JSON put if no image
            try {
                const response = await axios.put(`${API_URL}${id}/`, postData);
                return response.data;
            } catch (error) {
                console.error(`Error updating post #${id}:`, error);
                throw error;
            }
        }
    },

    /**
     * Delete a post
     * @param {number} id Post ID to delete
     * @returns {Promise} Promise with deletion result
     */
    deletePost: async (id) => {
        try {
            const response = await axios.delete(`${API_URL}${id}/`);
            return response.data;
        } catch (error) {
            console.error(`Error deleting post #${id}:`, error);
            throw error;
        }
    }
};

export default corporateService;